import styled from "styled-components";

const ViewAssinatura = styled.div`
  padding: 4rem;
  max-width: 80rem;
  margin: 0 auto;
  color: ${(props) => props.theme.colors.tertiary};

  .state {
    padding: 4rem 2rem;
    text-align: center;
    color: ${(props) => props.theme.colors.tertiary};

    &.erro {
      color: ${(props) => props.theme.colors.brandDanger};
    }
  }
`;

const ViewAssinaturaNova = styled.div`
  padding: 5rem 5rem 5rem 10rem;
  color: #626262;
  display: grid;
  grid-template-columns: calc(40% - 2px - 4rem) 2px calc(50% - 4rem);
  gap: 10rem;
  align-items: stretch;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    padding: 3.2rem;

    .divisor-vertical {
      display: none;
    }
  }

  .coluna-esquerda {
    display: flex;
    flex-direction: column;
    gap: 3.2rem;
  }

  .divisor-vertical {
    background-color: #e5e5e5;
    width: 1px;
  }

  .coluna-direita {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 3.2rem;
  }

  .secao-titulo {
    color: #2a844e;
    font-weight: 700;
    font-size: 20px;
    line-height: 1;
    padding-bottom: 0.8rem;
    text-align: left;
  }

  .bloco {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
  }

  .botoes-acoes {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.8rem;
  }

  .bloco-forms {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }

  .linha-dupla {
    display: flex;
    gap: 1.6rem;

    .campo {
      flex: 1 1 0;
      min-width: 0;
    }
  }

  .campo {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;

    .campo-label {
      color: #626262;
      font-size: 14px;
      line-height: 1;
      display: flex;
      align-items: center;
      gap: 0.8rem;
    }

    .campo-valor {
      background-color: #ffffff;
      border-radius: 32px;
      padding: 0.8rem 1.6rem;
      height: 33px;
      box-sizing: border-box;
      color: #626262;
      font-size: 14px;
      line-height: 1;
      display: flex;
      align-items: center;
    }

    .valor-riscado {
      text-decoration: line-through;
      font-size: 12px;
      margin-right: 0.5rem;
    }
  }

  .cupom-badge {
    background-color: #0d5229;
    color: #ffffff;
    padding: 0.1rem 0.8rem;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 400;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    height: 18px;
  }

  .proximo-vencimento {
    color: #626262;
    font-size: 14px;
    line-height: 1;
    text-align: left;
  }

  .botao-trocar-plano {
    align-self: flex-end;
    background-color: #0d5229;
    color: #ffffff;
    font-weight: 400;
    font-size: 14px;
    padding: 0.4rem 4rem;
    border-radius: 30px;
    border: none;
    cursor: pointer;
    text-decoration: none;
    line-height: 1.4;

    &:hover {
      opacity: 0.9;
    }
  }

  .alert {
    border-radius: 16px;
    padding: 0.4rem 0.8rem;
    border: 0.5px solid;
    display: flex;
    flex-direction: column;

    .alert-conteudo {
      padding: 2rem 4rem;
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      text-align: left;
    }

    .alert-titulo {
      font-weight: 700;
      font-size: 16px;
      line-height: 1;
      color: #626262;
      text-align: left;
    }

    .alert-texto {
      font-size: 12px;
      line-height: 1.3;
      color: #626262;
      text-align: left;
    }

    .alert-link {
      align-self: flex-start;
      background: none;
      border: none;
      padding: 0.4rem 0;
      cursor: pointer;
      font-size: 12px;
      text-decoration: underline;

      &:disabled {
        opacity: 0.6;
        cursor: default;
      }
    }

    &.vermelho {
      background-color: #ffe3e3;
      border-color: #c92a2a;
    }

    &.amarelo {
      background-color: #fff4da;
      border-color: #c87a00;

      .alert-titulo {
        color: #c87a00;
      }

      .alert-link {
        color: #c87a00;
      }
    }
  }

  .divisor-horizontal {
    width: 160px;
    height: 1px;
    background-color: #e5e5e5;
    align-self: center;
  }

  .header-fatura {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.8rem;
  }

  .link-ja-paguei {
    background: none;
    border: none;
    color: #626262;
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0;

    &:disabled {
      opacity: 0.6;
      cursor: default;
    }

    &:hover:not(:disabled) {
      text-decoration: underline;
    }
  }

  .acoes-fatura {
    display: flex;
    gap: 1.6rem;
    justify-content: flex-end;

    button {
      background-color: #0d5229;
      color: #ffffff;
      font-weight: 400;
      font-size: 14px;
      padding: 0.4rem 4rem;
      border-radius: 30px;
      border: none;
      cursor: pointer;
      line-height: 1.4;

      &:hover:not(:disabled) {
        opacity: 0.9;
      }
      &:disabled {
        opacity: 0.6;
        cursor: default;
      }
    }
  }

  .suporte {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;

    .suporte-texto {
      color: #626262;
      font-size: 14px;
      text-align: center;
    }

    .suporte-botao {
      background-color: #0d5229;
      color: #ffffff;
      font-weight: 400;
      font-size: 14px;
      padding: 0.4rem 4rem;
      border-radius: 30px;
      text-decoration: none;
      line-height: 1.4;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .state {
    padding: 4rem 2rem;
    text-align: center;
    color: #626262;
    grid-column: 1 / -1;

    &.erro {
      color: ${(props) => props.theme.colors.brandDanger};
    }
  }
`;

const ViewPagarFatura = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

  /* Nota da retenção fiscal, abaixo dos campos Valor/Vencimento. */
  .nota-retencao {
    color: #626262;
    font-size: 14px;
    line-height: 1.2;
    text-align: left;
  }

  /* PIX inline: QR à esquerda, instruções/copiar/expiração à direita. */
  .pix-inline {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
  }

  .pix-conteudo {
    display: flex;
    gap: 1.6rem;
    align-items: center;
  }

  .qr-wrapper {
    flex: 0 0 30%;
    max-width: 30%;
    box-sizing: border-box;
    background-color: #ffffff;
    padding: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .qr-imagem {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .pix-info {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1.6rem;

    .pix-instrucao,
    .pix-aviso-texto {
      color: #4a4a4a;
      font-size: 11px;
      line-height: 1.35;
      text-align: left;
    }

    .btn-copiar-pix {
      align-self: flex-start;
      background-color: #0d5229;
      color: #ffffff;
      font-weight: 700;
      font-size: 14px;
      border: none;
      border-radius: 30px;
      padding: 0.4rem 2.4rem;
      cursor: pointer;
      white-space: nowrap;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  .aguardando-pagamento {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 13px;
    color: #626262;

    .spinner {
      width: 18px;
      height: 18px;
      border: 2px solid #e5e5e5;
      border-top-color: #0d5229;
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
      flex-shrink: 0;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  }

  /* Spinner pequeno dentro do botão "Já paguei, atualizar" durante o polling. */
  .spinner-inline {
    width: 13px;
    height: 13px;
    border: 2px solid #cfcfcf;
    border-top-color: #626262;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    flex-shrink: 0;
    display: inline-block;
  }
`;

const ViewModalPagamento = styled.div`
  padding: 1rem 0;
  color: ${(props) => props.theme.colors.tertiary};

  .form-cartao {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .linha-dupla {
      display: flex;
      gap: 1.5rem;

      > * {
        flex: 1 1 0;
        min-width: 0;
      }
    }
  }

  .qr-wrapper {
    display: flex;
    justify-content: center;
    margin: 2rem 0;

    .qr-imagem {
      max-width: 24rem;
      width: 100%;
      height: auto;
      border: 1px solid ${(props) => props.theme.colors.elements};
      border-radius: 8px;
      padding: 1rem;
      background: white;
    }
  }

  .pix-codigo-label {
    font-size: 13px;
    color: ${(props) => props.theme.colors.tertiary};
    margin-top: 1.5rem;
  }

  .pix-codigo {
    word-break: break-all;
    font-family: monospace;
    font-size: 12px;
    padding: 1rem;
    background-color: ${(props) => props.theme.colors.elements};
    border-radius: 8px;
    margin-top: 0.5rem;
    color: ${(props) => props.theme.colors.secondary};
  }

  .pix-aviso {
    margin-top: 2rem;
    padding: 1.2rem;
    background-color: ${(props) => props.theme.colors.elements};
    border-radius: 8px;
    font-size: 13px;
    color: ${(props) => props.theme.colors.tertiary};
    line-height: 1.5;
  }

  .aguardando-pagamento {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-top: 1.5rem;
    padding: 1.2rem;
    background-color: ${(props) => props.theme.colors.elements};
    border-radius: 8px;
    color: ${(props) => props.theme.colors.tertiary};
    font-size: 13px;

    .spinner {
      width: 18px;
      height: 18px;
      border: 2px solid ${(props) => props.theme.colors.elements};
      border-top-color: ${(props) => props.theme.colors.primary};
      border-radius: 50%;
      animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  }

  .ja-paguei-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin-top: 1.5rem;

    .pix-aviso-texto {
      font-size: 13px;
      color: ${(props) => props.theme.colors.tertiary};
      text-align: center;
    }
  }

  .acoes-modal {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-top: 2rem;

    button {
      white-space: nowrap;
    }

    .cinza {
      color: ${(props) => props.theme.colors.tertiary};
      font-weight: normal;
      background-color: ${(props) => props.theme.colors.elements};
    }

    @media (max-width: 600px) {
      flex-direction: column-reverse;
      button {
        width: 100%;
      }
    }
  }
`;

const ViewListaFaturas = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  .tabela {
    display: flex;
    flex-direction: column;
  }

  .cabecalho,
  .linha {
    display: grid;
    grid-template-columns: 0.5fr 1.3fr 1fr 1fr 1fr 1fr;
    gap: 1.6rem;
    padding: 0.2rem 0.4rem;
    align-items: center;
  }

  .cabecalho {
    color: #626262;
    font-weight: 700;
    font-size: 14px;
    padding-bottom: 1.6rem;

    span:first-child {
      justify-self: start;
      /* Alinha "Nº" com os números (slot 2rem + gap 0.7rem da seta). */
      padding-left: 2.7rem;
    }
    span:not(:first-child) {
      justify-self: center;
    }
  }

  .linha {
    color: #626262;
    font-size: 14px;
    padding: 1rem 0.4rem 1rem;
    /* Zebra: base branca, faixa em background2 (padrão do projeto — Table).
       Setar as DUAS é necessário: o fundo atrás da tabela também é cinza,
       então só a faixa não apareceria. */
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 16px;

    span:first-child {
      justify-self: start;
    }
    span:not(:first-child):not(.status-badge) {
      justify-self: center;
    }
  }

  .linha.zebra {
    background-color: ${(props) => props.theme.colors.background2};
  }

  /* Nº + chevron na mesma célula. Slot fixo mantém o número sempre alinhado,
     tenha a linha seta ou não. */
  .col-num {
    display: inline-flex;
    align-items: center;
    gap: 0.7rem;
  }

  .chevron-slot {
    width: 2rem;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .btn-chevron {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: #626262;
    display: inline-flex;
    align-items: center;
  }

  /* Badges suaves com borda (só nesta tabela). O verde sólido migrou p/ .btn-baixar. */
  .status-badge {
    padding: 0.4rem 1.6rem;
    border-radius: 24px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    justify-self: stretch;
    height: 23px;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;

    &.status-pago {
      background-color: #f0fdf4;
      color: #34c759;
      border-color: #34c759;
    }
    &.status-aguardando {
      background-color: #ffe3e3;
      color: #c92a2a;
      border-color: #c92a2a;
    }
    &.status-vencido {
      background-color: #ffc9c9;
      color: #a02020;
      border-color: #a02020;
    }
    &.status-cancelado {
      background-color: #f6f6f6;
      color: #626262;
      border-color: #d0d0d0;
    }
  }

  /* Botão/link "Baixar" — verde sólido que antes era do badge "Pago". */
  .btn-baixar {
    background-color: #0d5229;
    color: #ffffff;
    font-weight: 700;
    font-size: 14px;
    border: none;
    border-radius: 30px;
    padding: 0.4rem 2.4rem;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }

  .vazio {
    color: #626262;
    font-size: 14px;
    padding: 2rem 0.4rem;
    text-align: center;
  }
`;

export {
  ViewAssinatura,
  ViewAssinaturaNova,
  ViewPagarFatura,
  ViewModalPagamento,
  ViewListaFaturas,
};
